<template>
  <div class="feedback">
    <div class="title">
      <span>*</span>所属模块
    </div>
    <div class="belongModule">
      <a-radio-group v-model="moduleType" button-style="solid" @change="selectModule" size="small">
        <a-radio-button v-for="item in moduleList" :key="item.id" :value="item.id">{{ item.content }}</a-radio-button>
      </a-radio-group>
    </div>
    <!--  各个模块快速选项列表  -->
    <div class="moduleList">
      <a-radio-group v-model="selectType" @change="changeCanSubmit">
        <a-radio v-for="data in quickOptionList" :style="radioStyle" :value="data.id">
          {{ data.content }}
        </a-radio>
      </a-radio-group>
    </div>
    <div class="title">
      其他问题
    </div>
    <div>
      <textarea v-model="text" maxlength="300" placeholder="请描述具体问题" @change="changeCanSubmit"></textarea>
    </div>
    <div class="title">上传截图 <span class="description">（最多5张）</span></div>
    <div class="uploadFiles">
      <div class="clearfix" v-if="systemType == 1">
        <a-upload
            list-type="picture-card"
            accept="image/*"
            :file-list="iosFileList"
            :customRequest="uploadFile"
            @change="handleChange"
            @preview="handlePreview">
          <div v-if="iosFileList.length < 5">
            <a-icon type="plus"/>
          </div>
        </a-upload>
        <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
          <img alt="example" style="width: 100%" :src="previewImage"/>
        </a-modal>
      </div>
      <div class="uploadFileList" v-else>
        <uploadFile v-for="(item,index) in fileList" @androidUploadFile="androidUploadFile" :index="index"
                    @deleteImg="deleteImg" :url="item"></uploadFile>
      </div>
    </div>
    <a-button type="primary" shape="round" size="large" block @click="submit" :disabled="canSubmit">
      提交
    </a-button>
  </div>
</template>

<script>
import request from "@/axios/request";
import uploadFile from "@/components/uploadFile";

let domain = ''
if (window.location.hostname.indexOf('test-') !== -1) {
  domain = 'https://test-plat.cnabke.com'
} else if (window.location.hostname.indexOf('dev-') !== -1) {
  domain = 'https://dev-plat.cnabke.com'
} else {
  domain = 'https://plat.cnabke.com'
}

export default {
  name: 'feedback',
  data() {
    return {
      canSubmit: true,
      text: '',
      moduleType: '0', // 反馈模块
      selectType: null, // 模块快速选项
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
      },
      systemType: 1, // 记录手机是安卓还是ios 安卓为0  ios为1
      token: '',
      accountId: '',
      memId: '',
      moduleList: [],
      quickOptionList: [],
      previewVisible: false,
      previewImage: '',
      fileList: [''],
      memUploadId: 0,
      memUploadIdList: [],
      iosFileList: []
    }
  },
  mounted() {
    // 获取系统信息
    this.getSystem();
    // 获取移动端入参
    this.token = this.$route.query.token
    this.accountId = this.$route.query.accountId
    this.memId = this.$route.query.memId
    localStorage.setItem("abke-token", this.token)
    request({
      url: '/app-crm/feedback/selectFeedbackConfigParentList',
      method: 'post'
    }).then(res => {
      this.moduleList = res.data
    })

    this.connectWebViewJavascriptBridge(bridge => {
      bridge.registerHandler("nativeCallJs", (data, responseCallback) => {
        let msg = JSON.parse(data)
        msg.data = JSON.parse(msg.data)
        if (msg) {
          // 更新token
          if (msg.action === 'action_update_picture') {
            this.fileList.pop()
            this.fileList.push(msg.data.url)
            this.memUploadIdList.push(msg.data.fileId)
            if (this.fileList.length < 5) {
              this.fileList.push('')
            }
          }
          // 收到消息后回传信息
          // responseCallback(responseData);
        }
      });
    })

  },
  methods: {
    // 查看是否可以提交
    changeCanSubmit() {
      if (this.moduleType !== '0' && (this.selectType !== null || this.text !== '')) {
        this.canSubmit = false
      } else {
        this.canSubmit = true
      }
    },
    // 获取系统信息 判断是Android还是iOS
    getSystem() {
      let u = navigator.userAgent;
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      if (isiOS) {
        this.systemType = 1
      } else if (isAndroid) {
        this.systemType = 0
      }
    },
    // jsBridge 建立连接 与移动端互通数据方法
    connectWebViewJavascriptBridge(callback) {
      if (window.WebViewJavascriptBridge) {
        callback(WebViewJavascriptBridge);
      } else {
        document.addEventListener(
            'WebViewJavascriptBridgeReady'
            , function () {
              callback(WebViewJavascriptBridge)
            },
            false
        );
      }
    },
    androidUploadFile() {
      //call native method
      window.WebViewJavascriptBridge.callHandler(
          'jsCallNative'
          , {'action': 'action_common_operation', 'data': '{"actionType":"NATIVE", "jumpUrl":"takePhotos"}'}
          , function (responseData) {

          }
      );
    },
    selectModule(e) {
      if (e.target.value === '604584faf363536df7fbfceb') {
        this.canSubmit = false
      } else {
        this.changeCanSubmit()
      }
      this.selectType = null
      request({
        url: '/app-crm/feedback/selectFeedbackConfigChildrenList',
        method: 'post',
        data: {
          id: e.target.value
        }
      }).then(res => {
        this.quickOptionList = res.data
      })
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    deleteImg(index) {
      if (this.fileList.length === 5 && this.fileList[4] !== '') {
        this.fileList.push('')
      }
      this.fileList.splice(index, 1);
      this.memUploadIdList.splice(index, 1);
    },
    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    uploadFile(info) {
      const params = new FormData()
      params.append('file', info.file)
      request({
        url: '/admin/manager/file/uploadFile.do',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'post',
        data: params
      }).then((res) => {
        info.onProgress({ percent: '100.00' }, info.fileList)
        info.onSuccess(res, info.file)
      })
    },
    handleChange(info) {
      this.iosFileList = info.fileList
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name} 上传成功`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败`)
      }
    },
    submit() {
      if (this.moduleType === '0') {
        this.message.create('error', '请选择所属模块')
        return
      }
      let memUploadIdList = []
      if (this.systemType === 1) {
        this.iosFileList.map(item => {
          memUploadIdList.push(item.response.result.memUploadId)
        })
      } else {
        memUploadIdList = this.memUploadIdList
      }
      request({
        url: '/app-crm/feedback/saveFeedbackInfo',
        method: 'post',
        data: {
          appId: 1,
          feedbackConfigPid: this.moduleType,
          feedbackConfigId: this.selectType,
          problem: this.text,
          memId: this.memId,
          accountId: this.accountId,
          memUploadIdList: memUploadIdList
        }
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('提交成功');
          this.quickOptionList = []
          this.canSubmit = true
          this.text = ''
          this.moduleType = '0'
          this.selectType = null
          this.fileList = ['']
          this.iosFileList = []
          this.memUploadIdList = []
        } else {
          this.$message.success('提交失败请稍后重试');
        }
      })
    }
  },
  components: {
    uploadFile
  }

}
</script>
<style>
.feedback .belongModule .ant-radio-group {
  display: flex;
  font-size: 14px;
  justify-content: space-around;
}

.feedback .belongModule .ant-radio-button-wrapper {
  border-radius: 4px;
  font-size: 13px;
}

body {
  padding: 0 15px;
}
</style>
<style scoped>
.title {
  margin: 30px 0 10px;
  font-size: 14px;
}

.belongModule {
  margin-bottom: 30px;
}

.title > span {
  color: #F22828;
}

.title > .description {
  color: #999999;
}

textarea {
  padding: 15px;
  width: 345px;
  height: 140px;
  border: 1px solid #333333;
  border-radius: 4px;
  resize: none;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.uploadFileList {
  display: flex;
  flex-wrap: wrap;
}

</style>
